import { InputCheckbox } from '@creditornot/cb-checkbox';
import { cssThemedValue, typographyCss } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
  padding-inline-end: 24px;
  width: 100%;
  ${typographyCss.Overline3};
  color: ${cssThemedValue('textSecondary')};
`;

const BoldText = styled.div`
  font-weight: 600;
  color: ${cssThemedValue('textPrimary')};
`;

const RightJustifiedText = styled.div`
  margin-inline-start: auto;
`;

const StyledCheckbox = styled(InputCheckbox)`
  margin: 0 16px;
`;

type Props = {
  numVenues: number;
  numSelectedVenues: number;
  onCheck: () => void;
  onUncheck: () => void;
  isCheckboxDisabled: boolean;
  brandName?: string;
};

const TableHeader: React.FC<Props> = ({
  isCheckboxDisabled,
  onCheck,
  onUncheck,
  brandName,
  numVenues,
  numSelectedVenues,
}: Props) => {
  const tableLabel = brandName || <FormattedMessage id="merchantSearch.venues" />;
  const partiallyChecked = numSelectedVenues > 0 && numSelectedVenues < numVenues;

  return (
    <HeaderRow>
      <StyledCheckbox
        disabled={isCheckboxDisabled}
        checked={numSelectedVenues === numVenues}
        partiallyChecked={partiallyChecked}
        onClick={event => {
          event.stopPropagation();

          if (event.currentTarget.checked) {
            onCheck();
          } else {
            onUncheck();
          }
        }}
      />
      <BoldText>{tableLabel}</BoldText>
      <RightJustifiedText>
        <FormattedMessage
          id="purchases.merchant.fraction-selected"
          values={{ fraction: `${numSelectedVenues}/${numVenues}` }}
        />
      </RightJustifiedText>
    </HeaderRow>
  );
};

export default TableHeader;
